<template>
  <div class="container-fluid px-0 py-0">
    <!-- --------- -->
    <!-- MARKERS   -->
    <!-- --------- -->
    <div class="bb-markers-strip rounded">
      <div
        class="bb-markers-group"
        :class="{
          'bb-markers-group-disabled': previous_round_overlay || disabled,
        }"
      >
        <div
          v-if="previous_round_overlay || disabled"
          class="bb-markers-group-overlay"
        ></div>
        <div class="bb-markers-heading">
          <span class="bb-hdg text-center"><p>Markers</p></span>
        </div>
        <!-- ------------------------------------------ -->
        <!-- 1. counter -->
        <div class="bb-marker-item ms-3">
          <ToolTip
            text="Counter"
            position="bottom"
          >
            <img
              id="counter"
              class="img-fluid rounded bb-img-norm-border bb-hover bb-marker-panel-icon"
              :src="getMarkerImg('counter')"
              @click="markerClick"
              alt="counter marker image"
            />
          </ToolTip>
        </div>
        <div class="bb-marker-item">
          <ToolTip
            text="Buff Magic"
            position="bottom"
          >
            <img
              id="magicked_positively"
              class="img-fluid rounded bb-img-norm-border bb-hover bb-marker-panel-icon"
              :src="getMarkerImg('magicked_positively')"
              @click="markerClick"
              alt="magic positive marker image"
            />
          </ToolTip>
        </div>
        <!-- ------------------------------------------ -->
        <!-- 3. magic-negative -->
        <div class="bb-marker-item">
          <ToolTip
            text="Nerf Magic"
            position="bottom"
          >
            <img
              id="magicked_negatively"
              class="img-fluid rounded bb-img-norm-border bb-hover bb-marker-panel-icon"
              :src="getMarkerImg('magicked_negatively')"
              @click="markerClick"
              alt="magic negative marker image"
            />
          </ToolTip>
        </div>
        <div class="bb-marker-item">
          <ToolTip
            text="Poisoned"
            position="bottom"
          >
            <img
              id="poisoned"
              class="img-fluid rounded bb-img-norm-border bb-hover bb-marker-panel-icon"
              :src="getMarkerImg('poisoned')"
              @click="markerClick"
              alt="poison marker image"
            />
          </ToolTip>
        </div>
        <!-- ------------------------------------------ -->
        <!-- 5. pysch -->
        <div class="bb-marker-item">
          <ToolTip
            text="Pysched"
            position="bottom"
          >
            <img
              id="psyched"
              class="img-fluid rounded bb-img-norm-border bb-hover bb-marker-panel-icon"
              :src="getMarkerImg('psyched')"
              @click="markerClick"
              alt="psych marker image"
            />
          </ToolTip>
        </div>
        <div class="bb-marker-item">
          <ToolTip
            text="Constrained"
            position="bottom"
          >
            <img
              id="constrained"
              class="img-fluid rounded bb-img-norm-border bb-hover bb-marker-panel-icon"
              :src="getMarkerImg('constrained')"
              @click="markerClick"
              alt="constrained marker image"
            />
          </ToolTip>
        </div>
        <!-- ------------------------------------------ -->
        <!-- 7. special -->
        <div class="bb-marker-item">
          <ToolTip
            text="Special Marker"
            position="bottom"
          >
            <img
              id="special_marker"
              class="img-fluid rounded bb-img-norm-border bb-hover bb-marker-panel-icon"
              :src="getMarkerImg('special_marker')"
              @click="markerClick"
              alt="special marker image"
            />
          </ToolTip>
        </div>
      </div>
      <div class="bb-marker-round-controls">
        <button
          type="button"
          :disabled="isPreviousViewRoundDisabled"
          class="btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center bb-marker-round-button"
          @click="previousViewRound()"
        >
          <ToolTip
            text="View Previous Round"
            position="bottom"
          >
            <img
              :src="previousViewRoundImg"
              :class="{
                'bb-marker-round-icon-disabled': isPreviousViewRoundDisabled,
              }"
              height="48"
              width="48"
              alt="previous view round image"
            />
          </ToolTip>
        </button>
        <button
          type="button"
          :disabled="isNextViewRoundDisabled"
          class="btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center bb-marker-round-button"
          @click="nextViewRound()"
        >
          <ToolTip
            text="View Next Round"
            position="bottom"
          >
            <img
              :src="nextViewRoundImg"
              :class="{
                'bb-marker-round-icon-disabled': isNextViewRoundDisabled,
              }"
              height="48"
              width="48"
              alt="next view round image"
            />
          </ToolTip>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import getConfig from '../helpers/getConfig'
import ToolTip from '../components/ToolTip.vue'
import nextViewRoundImg from '../assets/images/bbRndNext.png'
import previousViewRoundImg from '../assets/images/bbRndPrevious.png'
//==========================================================
// scripts
//---------
export default {
  name: 'MarkersPanel',
  watch: {
    disabled(newValue) {
      if (newValue) {
        this.clearMarkerSelection()
      }
    },
    previous_round_overlay(newValue) {
      if (newValue) {
        this.clearMarkerSelection()
      }
    },
  },
  //==========================================================
  // components
  //------------
  components: { ToolTip },
  //==========================================================
  // props
  //-------
  props: {
    markers: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    arena_active_combatants: {
      type: Number,
      required: true,
    },
    arena_extra_action: {
      type: Number,
      required: true,
    },
    arena_in_progress: {
      type: Boolean,
      required: true,
    },
    arena_rolled: {
      type: Boolean,
      required: true,
    },
    arena_round: {
      type: Number,
      required: true,
    },
    outstanding_rolls: {
      type: Boolean,
      required: true,
    },
    toggleNumbers: {
      type: Boolean,
      required: true,
    },
    previous_round_overlay: {
      type: Boolean,
      default: false,
    },
    view_round: {
      type: Number,
      required: true,
    },
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      marker_images: [],
      new_markers: [],
      nextViewRoundImg,
      previousViewRoundImg,
      savemarkerId: '',
    }
  },
  computed: {
    disableNoActiveCombatants() {
      return this.arena_active_combatants == 0
    },
    isPreviousViewRoundDisabled() {
      // console.log('isPreviousViewRoundDisabled called....')
      // console.log(
      //   'disablePreviousViewRoundButton:',
      //   this.disablePreviousViewRoundButton,
      // )
      // console.log(
      //   'disableViewRoundNavigation:',
      //   this.disableViewRoundNavigation,
      // )
      // console.log('disableNoActiveCombatants:', this.disableNoActiveCombatants)
      // console.log('toggleNumbers:', this.toggleNumbers)
      return (
        this.disablePreviousViewRoundButton ||
        this.disableViewRoundNavigation ||
        this.disableNoActiveCombatants ||
        this.toggleNumbers
      )
    },
    isNextViewRoundDisabled() {
      // console.log('isNextViewRoundDisabled called....')
      // console.log(
      //   'disableNextViewRoundButton:',
      //   this.disableNextViewRoundButton,
      // )
      // console.log(
      //   'disableViewRoundNavigation:',
      //   this.disableViewRoundNavigation,
      // )
      // console.log('disableNoActiveCombatants:', this.disableNoActiveCombatants)
      // console.log('toggleNumbers:', this.toggleNumbers)
      return (
        this.disableNextViewRoundButton ||
        this.disableViewRoundNavigation ||
        this.disableNoActiveCombatants ||
        this.toggleNumbers
      )
    },
    disablePreviousViewRoundButton() {
      return this.view_round <= 1
    },
    disableViewRoundNavigation() {
      return (
        !this.arena_in_progress || !this.arena_rolled || this.outstanding_rolls
      )
    },
    disableNextViewRoundButton() {
      let config = getConfig()
      return (
        this.view_round == this.arena_round + config.max_view_round_increment ||
        this.arena_active_combatants < 2
      )
    },
  },
  //==========================================================
  // methods
  //---------
  methods: {
    clearMarkerSelection() {
      if (this.savemarkerId) {
        const marker = document.getElementById(this.savemarkerId)

        if (marker) {
          marker.style.borderColor = '#c2ccd6'
          marker.style.borderWidth = '0.5px'
          marker.style.opacity = '0.4'
        }
      }

      this.savemarkerId = ''
      this.changeSlotsOpacity({
        reset: true,
        slot_array: this.markers,
        resetOpacity: '0.4',
      })
      this.emitter.emit('panel-marker-selected', '')
    },
    //================================================
    // get marker image
    //------------------
    getMarkerImg(name) {
      let marker = this.markers.find((a) => a.name == name)
      return marker.image
    },
    //================================================
    // marker click
    //--------------
    markerClick(e) {
      if (this.disabled || this.previous_round_overlay) {
        return
      }

      let id = e.target.id // marker name
      var marker = document.getElementById(id)
      //-------------------------------
      // reset if click on same marker
      //-------------------------------
      if (id == this.savemarkerId) {
        marker.style.borderColor = '#c2ccd6'
        marker.style.borderWidth = '0.5px'
        marker.style.opacity = '0.4'
        this.savemarkerId = ''

        let parm = {
          reset: true,
          slot_array: this.markers,
          resetOpacity: '0.4',
        }
        //-----------------------
        // change slots capacity
        //-----------------------
        this.changeSlotsOpacity(parm)
        //----------------------
        // different id clicked
        //----------------------
      } else {
        //----------------------
        // highlight new marker
        //----------------------
        marker.style.borderColor = 'white'
        marker.style.borderWidth = '3px'
        marker.style.opacity = '1.0'
        //-------------------
        // reset save marker
        //-------------------
        if (this.savemarkerId != '') {
          var marker_save = document.getElementById(this.savemarkerId)
          marker_save.style.borderColor = '#c2ccd6'
          marker_save.style.borderWidth = '0.5px'
          marker_save.style.opacity = '0.4'
        }
        //-----------------
        // save clicked id
        //-----------------
        this.savemarkerId = id
        //-------------------
        // set slots opacity
        //-------------------
        let parm = {
          id: id,
          slot_array: this.markers,
        }
        this.changeSlotsOpacity(parm)
      }
      //----------------------
      // send selected marker
      //----------------------
      this.emitter.emit('panel-marker-selected', this.savemarkerId)
    },
    //================================================
    // change slots opacity
    //----------------------
    changeSlotsOpacity(parm) {
      for (let i = 0; i < parm.slot_array.length; i++) {
        var slot = document.getElementById(parm.slot_array[i].name)
        if (!slot) {
          continue
        }

        if (parm.reset) {
          slot.style.opacity = parm.resetOpacity ?? '0.4'
        } else if (parm.slot_array[i].name == parm.id) {
          slot.style.opacity = parm.selectedOpacity ?? '1.0'
        } else {
          slot.style.opacity = parm.unselectedOpacity ?? '0.4'
        }
      }
    },
    nextViewRound() {
      this.emitter.emit('next-view-round')
    },
    previousViewRound() {
      this.emitter.emit('previous-view-round')
    },
  },
  //==========================================================
  // mounted
  //--------
  mounted() {
    //========================================================
    // reset markers
    //----------------
    this.emitter.on('reset-panel-markers', (selected_marker) => {
      if (!selected_marker?.name) {
        this.savemarkerId = ''
        return
      }

      var marker = document.getElementById(selected_marker.name)

      if (marker) {
        //-----------------------
        // reset selected marker
        //-----------------------
        marker.style.borderColor = '#c2ccd6'
        marker.style.borderWidth = '0.5px'
        marker.style.opacity = '0.4'
      }

      this.savemarkerId = ''
      let parm = {
        reset: true,
        slot_array: this.markers,
        resetOpacity: '0.4',
      }
      //-----------------------
      // change slots capacity
      //-----------------------
      this.changeSlotsOpacity(parm)
    })

    if (this.disabled || this.previous_round_overlay) {
      this.clearMarkerSelection()
    }
  },
}
</script>

<style>
.bb-markers-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 0.4rem 1rem 1rem !important;
}

.bb-markers-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: nowrap;
  overflow: visible;
  position: relative;
}

.bb-markers-group-disabled {
  opacity: 0.35;
  filter: grayscale(1);
  pointer-events: none;
}

.bb-markers-group-overlay {
  position: absolute;
  inset: 0;
  background: rgba(31, 35, 39, 0.5);
  z-index: 2;
}

.bb-markers-heading {
  flex: 0 0 auto;
  min-width: 7rem;
}

.bb-marker-item {
  flex: 0 0 auto;
}

.bb-marker-round-controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  flex: 0 0 9.5rem;
  min-width: 9.5rem;
}

.bb-marker-round-button {
  flex: 0 0 70px;
}

.bb-marker-round-button:disabled {
  opacity: 1 !important;
  background-color: #1f2327 !important;
  border-color: #2a3035 !important;
}

.bb-marker-round-icon-disabled {
  opacity: 0.32;
  filter: grayscale(1);
}

.bb-marker-panel-icon {
  opacity: 0.4;
  width: 4.5rem;
  max-width: 100%;
  height: auto;
}
</style>
